<template>
     <div class="main">
    <div class="bg">
        <p class="title">亲爱的用户们：</p>
        <p class="content">为了能够让您访问更快更稳定，同时为您提供更好的体验，我们正在维护系统。
            因此目前网站的功能暂时停止使用，给您造成的不便，请谅解。 </p> 
    </div>
</div>
</template>

<script>
export default {
    name: 'weihu',
    data(){
        return{

        }
    },
    methods: {
        test(){
           this.$router.push({ name: 'checkPhone'}) 
        }
    }
}
</script>
<style scoped>
 .main{
      background: #F9FAFE;
      display: flex;
      justify-content:center;
      align-items: center;
      height: 100vh;
  }
  .bg{
      background: url('https://mail-mgmt.tongji.edu.cn/weihu.png') no-repeat;
      width: 855px;
      height: 343px;
  }
  .bg p{
    font-size: 16px;
    color: #333;
    padding-left: 240px;
    padding-right: 50px;
  }
  .title{
      margin-top: 150px;
  }
  .content{
      margin-top: 5px;
      text-indent: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/page/maintain.vue